import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from '@heroui/react';
import { Tooltip } from '@/components/Tooltip';
import { CHAT_WALLPAPERS, setChatWallpaper, useChatSurfacePrefs, type ChatSurface } from '@/lib/chatSurfacePrefs';

/** Personal presentation only: no channel settings or shared data are changed. */
export function ChatAppearanceButton() {
  const { t } = useTranslation();
  const prefs = useChatSurfacePrefs();
  const [target, setTarget] = useState<ChatSurface>('chat');
  return <Popover>
    <Tooltip label={t('chatAppearance.title')}>
    <Popover.Trigger className="chat-appearance-trigger group" aria-label={t('chatAppearance.title')}>
      <svg className="group-hover:[animation:icon-shake_0.4s_ease-in-out_2]" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="8.5" cy="8.5" r="1.5" /><path d="m3 17 5-5 4 4 4-6 5 7" />
      </svg>
    </Popover.Trigger>
    </Tooltip>
    <Popover.Content placement="bottom end">
      <Popover.Dialog className="chat-appearance-picker" aria-label={t('chatAppearance.title')}>
        <h2 className="text-base font-semibold">{t('chatAppearance.title')}</h2>
        <p className="mt-1 text-xs text-muted">{t('chatAppearance.personal')}</p>
        <div className="chat-appearance-targets" role="group" aria-label={t('chatAppearance.target')}>
          {(['chat', 'members'] as const).map((id) => <button key={id} type="button" aria-pressed={target === id} onClick={() => setTarget(id)}>{t(`chatAppearance.${id}`)}</button>)}
        </div>
        <fieldset>
          <legend className="sr-only">{t('chatAppearance.choose')}</legend>
          <div className="chat-wallpaper-options">
            {CHAT_WALLPAPERS.map((id) => <label key={id} className="chat-wallpaper-option">
              <input type="radio" name={`wallpaper-${target}`} value={id} checked={prefs[target] === id} onChange={() => setChatWallpaper(target, id)} />
              <span className="chat-wallpaper-preview" data-wallpaper={id} aria-hidden><span /><span /><span /></span>
              <span className="chat-wallpaper-name">{t(`chatAppearance.presets.${id}`)}<span aria-hidden>{prefs[target] === id ? '✓' : ''}</span></span>
            </label>)}
          </div>
        </fieldset>
        <button className="chat-wallpaper-reset" type="button" aria-pressed={prefs[target] === 'none'} onClick={() => setChatWallpaper(target, 'none')}>{t('chatAppearance.reset')}</button>
      </Popover.Dialog>
    </Popover.Content>
  </Popover>;
}
